(function(){
  var reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  var SPARK = '<svg viewBox="0 0 100 100"><path d="M50 0C54 36 64 46 100 50C64 54 54 64 50 100C46 64 36 54 0 50C36 46 46 36 50 0Z" fill="currentColor"/></svg>';

  var mb = document.getElementById("menuBtn");
  if (mb) mb.addEventListener("click", function(){
    var n = document.getElementById("mainNav"); n.classList.toggle("open");
    mb.setAttribute("aria-expanded", n.classList.contains("open"));
  });

  // doodles: sparkle burst on hover, gentle parallax in the hero
  document.addEventListener("pointerover", function(e){
    var a = e.target.closest && e.target.closest(".dd");
    if (!a || reduce || a.contains(e.relatedTarget)) return;
    for (var i = 0; i < 6; i++) {
      var b = document.createElement("span"); b.className = "burst";
      var ang = Math.PI*2*i/6 + Math.random()*.5, r = 26 + Math.random()*14;
      b.style.setProperty("--bx", Math.cos(ang)*r + "px"); b.style.setProperty("--by", Math.sin(ang)*r + "px");
      b.innerHTML = SPARK; a.appendChild(b);
      setTimeout(function(x){ return function(){ x.remove(); }; }(b), 750);
    }
  });
  document.addEventListener("pointermove", function(e){
    if (reduce) return;
    var h = e.target.closest && e.target.closest(".hero"); if (!h) return;
    var r = h.getBoundingClientRect(), x = (e.clientX-r.left)/r.width - .5, y = (e.clientY-r.top)/r.height - .5;
    h.querySelectorAll(".dd").forEach(function(d){
      var k = +d.dataset.d || 0;
      d.style.setProperty("--px", (x*k).toFixed(1) + "px"); d.style.setProperty("--py", (y*k).toFixed(1) + "px");
    });
  });

  // logo video replay
  document.querySelectorAll(".vid-ring").forEach(function(w){
    var v = w.querySelector("video"), b = w.querySelector(".replay");
    if (v && b) b.addEventListener("click", function(){ v.currentTime = 0; v.play().catch(function(){}); });
  });

  // product page: gallery + variant picking
  var form = document.querySelector("[data-product-form]");
  if (form) {
    var data = JSON.parse(document.getElementById("productJson").textContent);
    var main = document.getElementById("mainImg");
    document.querySelectorAll(".thumb").forEach(function(t){
      t.addEventListener("click", function(){
        main.src = t.dataset.src; main.alt = t.dataset.alt || "";
        document.querySelectorAll(".thumb").forEach(function(o){ o.setAttribute("aria-pressed", o === t); });
      });
    });
    var idIn = form.querySelector("[name=id]"), btn = form.querySelector("[type=submit]"), price = document.getElementById("price");
    function pick(){
      var chosen = Array.prototype.map.call(form.querySelectorAll(".opt"), function(fs){
        var c = fs.querySelector("input:checked"); return c ? c.value : null;
      });
      var v = data.variants.find(function(v){ return v.options.every(function(o,i){ return o === chosen[i]; }); });
      if (!v) return;
      idIn.value = v.id;
      if (price) price.textContent = data.priceFrom ? price.textContent : v.price_fmt;
      btn.disabled = !v.available; btn.textContent = v.available ? btn.dataset.label : "Sold out";
      if (v.image && main) { main.src = v.image; }
      document.querySelectorAll("[data-opt-value]").forEach(function(s){
        var fsIndex = +s.dataset.optIndex; if (s.checked) document.querySelector('[data-opt-current="'+fsIndex+'"]').textContent = s.value;
      });
    }
    form.addEventListener("change", pick);
  }

  function money(c){ return "$" + (c/100).toFixed(2); }
  function esc(t){ return String(t).replace(/[&<>"]/g, function(m){ return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[m]; }); }
  function uid(){ return Math.random().toString(36).slice(2, 8).toUpperCase(); }

  // extras blocks shared by the personaliser and the clicker designer: +/- steppers and toggle chips
  function wireExtras(root, onChange){
    root.querySelectorAll(".stepper").forEach(function(st){
      var out = st.querySelector("output");
      st.querySelectorAll("[data-step]").forEach(function(b){
        b.addEventListener("click", function(){
          out.value = out.textContent = Math.max(0, Math.min(9, (+out.textContent) + (+b.dataset.step)));
          st.classList.toggle("on", +out.textContent > 0); onChange();
        });
      });
    });
    root.querySelectorAll(".extra[data-toggle] .chip").forEach(function(c){
      c.addEventListener("click", function(){ c.setAttribute("aria-pressed", c.getAttribute("aria-pressed") !== "true"); onChange(); });
    });
  }
  // what the shopper picked in each extras block: [{id, price, label, qty, names}]
  function readExtras(root){
    return Array.prototype.map.call(root.querySelectorAll(".extra"), function(x){
      var names = [], qty = 0;
      x.querySelectorAll(".stepper").forEach(function(st){
        var n = +st.querySelector("output").textContent;
        if (n) { qty += n; names.push(st.dataset.name + (n > 1 ? " x" + n : "")); }
      });
      x.querySelectorAll(".chip[aria-pressed=true]").forEach(function(c){ qty++; names.push(c.dataset.name); });
      return {id: +x.dataset.extra, price: +x.dataset.price, label: x.dataset.label, qty: qty, names: names};
    }).filter(function(e){ return e.qty > 0; });
  }
  function renderSum(root, base, lines){
    var total = base, html = "";
    lines.forEach(function(l){ total += l.price * l.qty; html += '<div class="pz-row"><span>' + esc(l.label) + ' <small class="muted">' + esc(l.names.join(", ")) + '</small></span><span>+' + money(l.price * l.qty) + '</span></div>'; });
    root.querySelector("[data-lines]").innerHTML = html;
    root.querySelector("[data-total]").textContent = money(total);
    return total;
  }
  // main item plus one line per extra, linked by a shared reference so the order reads clearly
  function addBundle(items, btn){
    btn.disabled = true; var label = btn.textContent; btn.textContent = "Adding…";
    fetch("/cart/add.js", {method: "POST", headers: {"Content-Type": "application/json", "Accept": "application/json"}, body: JSON.stringify({items: items})})
      .then(function(r){ if (!r.ok) throw r; window.location.href = "/cart"; })
      .catch(function(){ btn.disabled = false; btn.textContent = label; alert("Sorry, that didn't work. Please try again."); });
  }

  // personalised keychains: live total, then add keychain + extras together
  var pz = document.querySelector("[data-pz]");
  if (pz && form) {
    var pzForm = form, pd = JSON.parse(document.getElementById("productJson").textContent);
    var xd = document.getElementById("pzExtras"); xd = xd ? JSON.parse(xd.textContent) : {letter: null, title: ""};
    var nameIn = pz.querySelector("[data-pz-name]"), incl = +pz.dataset.included, field = pz.dataset.field;
    var lettersNote = pz.querySelector("[data-pz-letters]");
    function lines(){
      var l = readExtras(pz), n = nameIn.value.replace(/\s/g, "").length;
      if (xd.letter && n > incl) l.unshift({id: xd.letter.id, price: xd.letter.price, label: "Extra letters", qty: n - incl, names: [(n - incl) + " more"]});
      lettersNote.textContent = n > incl ? (xd.letter ? (n - incl) + " extra letter" + (n - incl > 1 ? "s" : "") + " added below." : "") : (incl - n) + " left in the base price.";
      return l;
    }
    function variant(){ var id = +pzForm.querySelector("[name=id]").value; return pd.variants.find(function(v){ return v.id === id; }) || pd.variants[0]; }
    function upd(){ renderSum(pz, variant().price, lines()); pz.querySelector("[data-base]").textContent = money(variant().price); }
    wireExtras(pz, upd);
    nameIn.addEventListener("input", function(){ nameIn.value = nameIn.value.toUpperCase(); upd(); });
    pzForm.addEventListener("change", function(){ setTimeout(upd); });
    upd();
    pzForm.addEventListener("submit", function(e){
      e.preventDefault();
      if (!nameIn.value.trim()) { nameIn.focus(); return; }
      var ref = uid(), q = Math.max(1, +pzForm.querySelector("[name=quantity]").value || 1), ex = lines();
      var props = {}; props[field] = nameIn.value.trim(); props._ref = ref;
      ex.forEach(function(x){ props[x.label] = x.names.join(", "); });
      var items = [{id: variant().id, quantity: q, properties: props}];
      ex.forEach(function(x){ items.push({id: x.id, quantity: x.qty * q, properties: {"For": xd.title + " · " + nameIn.value.trim(), "Details": x.names.join(", "), _ref: ref}}); });
      addBundle(items, pzForm.querySelector("[type=submit]"));
    });
  }

  // clicker designer: vertical preview, one key per slot, price by number of keys
  var ck = document.querySelector("[data-ck]");
  if (ck) {
    var cd = JSON.parse(document.getElementById("ckData").textContent);
    var hex = {}; cd.caps.forEach(function(c){ var kv = c.split(":"); hex[kv[0]] = kv[1]; });
    var slotsEl = ck.querySelector("[data-ck-slots]"), tpl = ck.querySelector("template[data-ck-slot]"), body = ck.querySelector("[data-ck-body]");
    var count = 4, palette = Object.keys(hex);
    function addSlot(i){
      var n = tpl.content.firstElementChild.cloneNode(true);
      n.querySelector(".ck-num").textContent = i + 1;
      n.querySelector("select").value = palette[i % palette.length];
      var inp = n.querySelector("input");
      inp.addEventListener("input", function(){ inp.value = inp.value.toUpperCase(); inp.dataset.pic = ""; n.querySelectorAll(".ck-pics button").forEach(function(b){ b.setAttribute("aria-pressed", "false"); }); draw(); });
      n.querySelectorAll(".ck-pics button").forEach(function(b){
        b.setAttribute("aria-pressed", "false");
        b.addEventListener("click", function(){ inp.value = b.dataset.pic; inp.dataset.pic = b.dataset.name; n.querySelectorAll(".ck-pics button").forEach(function(o){ o.setAttribute("aria-pressed", o === b); }); draw(); });
      });
      n.querySelector("select").addEventListener("change", draw);
      slotsEl.appendChild(n);
    }
    function setCount(c){
      count = c;
      while (slotsEl.children.length < c) addSlot(slotsEl.children.length);
      Array.prototype.forEach.call(slotsEl.children, function(s, i){ s.hidden = i >= c; });
      ck.querySelectorAll("[data-count]").forEach(function(b){ b.setAttribute("aria-pressed", +b.dataset.count === c); });
      ck.querySelector("[data-ck-keys]").textContent = c + " key" + (c > 1 ? "s" : "");
      draw();
    }
    function slots(){
      return Array.prototype.slice.call(slotsEl.children, 0, count).map(function(s){
        var inp = s.querySelector("input"), col = s.querySelector("select").value;
        return {txt: inp.value, label: inp.dataset.pic || inp.value, col: col};
      });
    }
    function draw(){
      body.innerHTML = slots().map(function(s){ var dark = s.col === "Black"; return '<span class="ck-key" style="background:' + hex[s.col] + (dark ? ';color:#fff' : '') + '">' + esc(s.txt || "") + "</span>"; }).join("");
      var v = cd.variants[count - 1];
      ck.querySelector("[data-base]").textContent = v ? money(v.price) : "Price soon";
      var l = readExtras(ck);
      if (v) renderSum(ck, v.price, l); else { renderSum(ck, 0, l); ck.querySelector("[data-total]").textContent = "Price soon"; }
    }
    ck.querySelectorAll("[data-count]").forEach(function(b){ b.addEventListener("click", function(){ setCount(+b.dataset.count); }); });
    document.querySelectorAll(".ck-size").forEach(function(b){ b.addEventListener("click", function(){ setCount(+b.dataset.size); document.getElementById("build").scrollIntoView({behavior: reduce ? "auto" : "smooth"}); }); });
    wireExtras(ck, draw);
    setCount(4);
    ck.addEventListener("submit", function(e){
      e.preventDefault();
      var v = cd.variants[count - 1]; if (!cd.live || !v) return;
      var s = slots(), empty = s.findIndex(function(x){ return !x.txt; });
      if (empty > -1) { slotsEl.children[empty].querySelector("input").focus(); return; }
      var ref = uid(), q = Math.max(1, +document.getElementById("ckQty").value || 1), props = {_ref: ref};
      s.forEach(function(x, i){ props["Key " + (i + 1)] = x.label + " · " + x.col; });
      var ex = readExtras(ck); ex.forEach(function(x){ props[x.label] = x.names.join(", "); });
      var items = [{id: v.id, quantity: q, properties: props}];
      ex.forEach(function(x){ items.push({id: x.id, quantity: x.qty * q, properties: {"For": "Custom clicker", "Details": x.names.join(", "), _ref: ref}}); });
      addBundle(items, ck.querySelector("[type=submit]"));
    });
  }

  // cart: preferred pick-up times for the next three weeks, one-hour slots
  var sel = document.querySelector("[data-slots]");
  if (sel) {
    var hours = {2: [10, 11, 17, 18], 3: [10, 11, 17, 18], 5: [10, 11, 17, 18], 6: [9, 10, 11]};
    var fmt = function(h){ var p = h >= 12 ? "pm" : "am", x = h % 12 || 12; return x + p; };
    var d = new Date(); d.setHours(0, 0, 0, 0); d.setDate(d.getDate() + 2);
    for (var i = 0; i < 21; i++, d.setDate(d.getDate() + 1)) {
      (hours[d.getDay()] || []).forEach(function(h){
        var t = d.toLocaleDateString("en-NZ", {weekday: "short", day: "numeric", month: "short"}) + ", " + fmt(h) + " to " + fmt(h + 1);
        var o = document.createElement("option"); o.value = o.textContent = t; sel.appendChild(o);
      });
    }
    if (sel.dataset.current) { if (!Array.prototype.some.call(sel.options, function(o){ return o.value === sel.dataset.current; })) { var o = document.createElement("option"); o.value = o.textContent = sel.dataset.current; sel.appendChild(o); } sel.value = sel.dataset.current; }
  }
  // little confirmation bubble
  var toast = function(html){
    var t = document.querySelector(".toast");
    if (!t) { t = document.createElement("div"); t.className = "toast"; t.setAttribute("role", "status"); document.body.appendChild(t); }
    t.innerHTML = html; t.classList.add("show");
    clearTimeout(t._h); t._h = setTimeout(function(){ t.classList.remove("show"); }, 3200);
  };

  // product cards: add simple products without leaving the page
  document.addEventListener("click", function(e){
    var b = e.target.closest("[data-quick-add]");
    if (!b) return;
    b.disabled = true; var label = b.textContent; b.textContent = "Adding...";
    fetch("/cart/add.js", {method: "POST", headers: {"Content-Type": "application/json", "Accept": "application/json"}, body: JSON.stringify({items: [{id: +b.dataset.quickAdd, quantity: 1}]})})
      .then(function(r){ if (!r.ok) throw r; return fetch("/cart.js"); })
      .then(function(r){ return r.json(); })
      .then(function(c){
        document.querySelectorAll(".cart-count").forEach(function(n){ n.textContent = c.item_count; });
        b.textContent = "Added ✓"; b.classList.add("is-done");
        if (document.dispatchEvent(new CustomEvent("its:added", {cancelable: true, detail: c}))) toast(esc(b.dataset.title) + " is in your bag. <a href=\"/cart\">View bag</a>");
        setTimeout(function(){ b.textContent = label; b.classList.remove("is-done"); b.disabled = false; }, 2200);
      })
      .catch(function(){ b.textContent = "Try again"; b.disabled = false; });
  });

  // product page: when it will leave the studio, counted in NZ working days
  var eta = document.querySelector("[data-eta]");
  if (eta) {
    var days = +eta.dataset.days || 2, d2 = new Date();
    if (d2.getHours() >= 14) d2.setDate(d2.getDate() + 1);
    while (days > 0) { d2.setDate(d2.getDate() + 1); if (d2.getDay() !== 0 && d2.getDay() !== 6) days--; }
    var when = d2.toLocaleDateString("en-NZ", {weekday: "long", day: "numeric", month: "short"});
    eta.lastElementChild.innerHTML = (eta.dataset.days > 2 ? "Order today and it's made and on its way by <b>" : "Order today and it ships by <b>") + when + "</b>. Tracked, 1 to 3 working days to arrive.";
  }

  // product page: a buy bar that follows on small screens once the main button scrolls away
  var bar = document.querySelector("[data-sticky-buy]"), mainBuy = document.querySelector("[data-main-buy]");
  if (bar && mainBuy && "IntersectionObserver" in window) {
    new IntersectionObserver(function(en){ var r = en[0]; bar.hidden = r.isIntersecting || r.boundingClientRect.top > 0; }).observe(mainBuy);
    bar.querySelector("[data-sticky-go]").addEventListener("click", function(){
      var form = mainBuy.form, name = form && form.querySelector("[data-pz-name]");
      if (name && !name.value.trim()) { name.scrollIntoView({behavior: "smooth", block: "center"}); name.focus({preventScroll: true}); return; }
      mainBuy.click();
    });
    var price = document.getElementById("price"), sp = bar.querySelector("[data-sticky-price]"), tot = document.querySelector("[data-total]");
    var sync = function(){ sp.textContent = (tot && tot.textContent.trim()) || price.textContent; };
    if (tot) new MutationObserver(sync).observe(tot, {childList: true, characterData: true, subtree: true});
  }

  // events: tapping an event type fills in the enquiry form
  document.querySelectorAll("[data-ev-kind],[data-ev-pick]").forEach(function(a){
    a.addEventListener("click", function(){
      var s = document.querySelector("[data-ev-select]"); if (!s) return;
      if (a.dataset.evKind) s.value = a.dataset.evKind;
      else { s.value = "Public workshop"; var t = document.querySelector("#eventForm textarea"); if (t && !t.value) t.value = "I'm interested in: " + a.dataset.evPick; }
    });
  });
})();

/* Hand-drawn doodles scattered around each section, purely decorative. */
(function(){
  var S = 'fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke"';
  var P = 'fill="var(--peach)" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" vector-effect="non-scaling-stroke"';
  var D = {
    heart: '<path d="M50 84C50 84 18 62 16 42C14 26 30 18 42 26C46 29 50 34 50 34C50 34 54 29 58 26C70 18 86 26 84 42C82 62 50 84 50 84Z" ' + P + '/><path d="M28 40c1-6 6-9 11-8" ' + S + ' opacity=".5"/>',
    star: '<path d="M50 8l12 25 27 4-20 19 5 27-24-13-24 13 5-27-20-19 27-4z" ' + S + '/>',
    sparkle: '<path d="M50 6C54 38 62 46 94 50C62 54 54 62 50 94C46 62 38 54 6 50C38 46 46 38 50 6Z" fill="currentColor" opacity=".8"/>',
    flower: (function(){ var s = ''; for (var a = 0; a < 5; a++) s += '<ellipse cx="50" cy="28" rx="12" ry="18" transform="rotate(' + (a * 72) + ' 50 50)" ' + P + '/>'; return s + '<circle cx="50" cy="50" r="9" fill="#F2D33B" stroke="currentColor" stroke-width="1.5" vector-effect="non-scaling-stroke"/>'; })(),
    keychain: '<circle cx="50" cy="16" r="11" ' + S + '/><ellipse cx="50" cy="33" rx="4" ry="6" ' + S + '/><ellipse cx="50" cy="43" rx="4" ry="6" ' + S + '/><rect x="30" y="50" width="40" height="42" rx="10" ' + P + '/><path d="M50 82C50 82 39 74 39 67C39 62 45 60 50 65C55 60 61 62 61 67C61 74 50 82 50 82Z" ' + S + '/>',
    plane: '<path d="M8 46L92 14L66 86L50 58Z" ' + S + '/><path d="M50 58L92 14M50 58L48 76L60 66" ' + S + '/><path d="M6 86C14 80 20 76 30 74" ' + S + ' stroke-dasharray="3 5"/>',
    globe: '<circle cx="50" cy="50" r="36" ' + S + '/><ellipse cx="50" cy="50" rx="15" ry="36" ' + S + '/><path d="M14 50h72M19 32Q50 40 81 32M19 68Q50 60 81 68" ' + S + '/>',
    bow: '<path d="M50 50C38 34 18 30 16 42C14 54 34 60 50 50Z" ' + P + '/><path d="M50 50C62 34 82 30 84 42C86 54 66 60 50 50Z" ' + P + '/><circle cx="50" cy="50" r="6" ' + S + '/><path d="M46 55L36 82M54 55L64 82" ' + S + '/>',
    cloud: '<path d="M26 70C14 70 10 56 20 50C18 38 32 30 42 38C46 26 66 24 70 40C82 38 90 50 84 60C82 66 78 70 72 70Z" ' + S + '/>',
    beads: (function(){ var s = '<path d="M10 40Q50 90 90 40" ' + S + ' opacity=".5"/>'; [[16,49],[28,60],[41,65],[54,65],[67,61],[79,53]].forEach(function(p, i){ s += '<circle cx="' + p[0] + '" cy="' + p[1] + '" r="6" ' + (i % 2 ? S : P) + '/>'; }); return s; })(),
    smiley: '<circle cx="50" cy="50" r="34" ' + S + '/><circle cx="39" cy="43" r="3" fill="currentColor"/><circle cx="61" cy="43" r="3" fill="currentColor"/><path d="M36 58c8 10 20 10 28 0" ' + S + '/>',
    butterfly: '<path d="M50 48C40 22 14 18 14 36C14 50 34 54 50 50Z" ' + P + '/><path d="M50 48C60 22 86 18 86 36C86 50 66 54 50 50Z" ' + P + '/><path d="M50 52C40 62 26 76 34 82C42 86 48 70 50 56ZM50 52C60 62 74 76 66 82C58 86 52 70 50 56Z" ' + S + '/><path d="M50 30V76M48 28L42 16M52 28L58 16" ' + S + '/>'
  };
  var css = document.createElement('style');
  css.textContent = ".jdeco{position:absolute;pointer-events:none;color:var(--coral);z-index:0;opacity:.62} .jdeco svg{width:100%;height:100%;display:block;overflow:visible} .jdeco.bob{animation:bob 5s ease-in-out infinite} .jdeco.sway{animation:sway 6s ease-in-out infinite} main section.band,main .ev-hero,main .ck-hero{position:relative;overflow-x:clip} main section.band>.wrap,main .ev-hero>.wrap,main .ck-hero>.wrap,main .page-head>*:not(.jdeco):not(.deco){position:relative;z-index:1} @media (max-width:820px){.jdeco{opacity:.42;width:42px!important;height:42px!important}.jdeco.sm-hide{display:none}} @media (prefers-reduced-motion:reduce){.jdeco{animation:none}}";
  document.head.appendChild(css);
  var order = ['heart','plane','flower','keychain','star','globe','bow','sparkle','cloud','beads','butterfly','smiley'];
  /* l/r/t/b are % offsets, s is the size in px, rot in degrees; sm hides the spot on phones */
  var spots = [
    [{l:2, t:12, s:74, rot:-12}, {r:2.5, b:10, s:62, rot:10, sm:1}, {r:5, t:20, s:24, tiny:1, sm:1}],
    [{r:2, t:10, s:70, rot:8}, {l:3, b:14, s:56, rot:-8, sm:1}, {l:6, t:46, s:22, tiny:1, sm:1}],
    [{l:3, b:12, s:68, rot:6}, {r:3, t:14, s:60, rot:-10, sm:1}, {r:7, b:30, s:26, tiny:1, sm:1}]
  ];
  var n = 0, m = 0;
  function add(host, name, sp, i){
    var el = document.createElement('span');
    el.className = 'jdeco ' + (i % 2 ? 'bob' : 'sway') + (sp.sm ? ' sm-hide' : '');
    el.setAttribute('aria-hidden', 'true');
    var st = 'width:' + sp.s + 'px;height:' + sp.s + 'px;animation-delay:' + (i % 4) * 0.8 + 's;';
    ['l', 'r', 't', 'b'].forEach(function(k){ if (sp[k] != null) st += {l:'left', r:'right', t:'top', b:'bottom'}[k] + ':' + sp[k] + '%;'; });
    el.style.cssText = st;
    el.innerHTML = '<svg viewBox="0 0 100 100" style="transform:rotate(' + (sp.rot || 0) + 'deg)">' + D[name] + '</svg>';
    host.appendChild(el);
  }
  document.querySelectorAll('main section.band, main .ev-hero, main .ck-hero').forEach(function(sec, k){
    if (sec.closest('.hero') || sec.querySelector(':scope > .jdeco')) return;
    var set = spots[k % spots.length];
    set.forEach(function(sp){ if (sp.tiny) { add(sec, n % 2 ? 'sparkle' : 'star', sp, n); n++; return; } add(sec, order[m % order.length], sp, n); m++; n++; });
  });
  document.querySelectorAll('main .page-head').forEach(function(ph){
    add(ph, order[m++ % order.length], {r:16, t:58, s:46, rot:-8, sm:1}, n); n++;
    add(ph, 'sparkle', {r:30, t:22, s:22, sm:1}, n); n++;
  });
})();
